import React from "react";
import { Switch, Route } from "react-router-dom";
import MainSwitch from "./components/nav/mainSwitch";
import Updater from "./components/newVersion/Updater";
import QSheetPrintView from "./components/PayEstimate/QSheetPrintView";

export default () => (
  <>
    <Updater />
    <Switch>
      <Route path="/qsheet/:id/print" component={QSheetPrintView} />
      <Route component={MainSwitch} />
    </Switch>
  </>
);
